import React, { useState, useEffect } from "react";
import { ExpandedAccordion } from "../../../shared/components/ui/ExpandedAccordion";

const ChildExpandRow = ({ item, onUpdate, viewMode = "expanded" }) => {
  const [localItem, setLocalItem] = useState(item);

  useEffect(() => {
    setLocalItem(item);
  }, [item]);

  const handleChildUpdate = (updatedParent) => {
    setLocalItem(updatedParent);
    if (onUpdate) onUpdate(updatedParent);
  };

  const sections = [
    {
      id: "child-info",
      title: "Child Information",
      fields: [
        { label: "Name", value: localItem?.name || "—" },
        { label: "Parent", value: localItem?.parent?.fullName || "—" },
        {
          label: "Date of Birth",
          value: localItem.dateOfBirth
            ? new Date(localItem.dateOfBirth).toLocaleDateString("en-US", {
                month: "short",
                day: "numeric",
                year: "numeric",
              })
            : "—",
        },
        { label: "Gender", value: localItem.gender || "—" },
        { label: "Blood Group", value: localItem.bloodGroup || "—" },
        {
          label: "Weight (kg)",
          value: localItem.weightKg || "—",
        },
        {
          label: "Height (cm)",
          value: localItem.heightCm || "—",
        },
        {
          label: "Relation with Child",
          value: localItem.relationWithChild || "—",
        }
      ],
    },

    {
      id: "child-medical-info",
      title: "Medical & Notes",
      fields: [
        {
          label: "Pediatrician",
          value: localItem.pediatrician || "-",
        },
        {
          label: "Allergies",
          value: localItem?.allergies?.length ? localItem?.allergies?.join(", ") : "Not recorded",
        },
        {
          label: "Medical Conditions",
          value: localItem.medicalConditions || "—",
        },
        { label: "Special Notes", value: localItem.specialNotes || "—", isLong: true },
      ],
    },
  ];

  // ✅ Only add children section for expanded view
  if (viewMode === "expanded" && Array.isArray(localItem.children)) {
    sections.splice(1, 0, {
      id: "children",
      title: "Children Information",
      isChildrenSection: true,
      children: localItem.children,
    });
  }

  return <ExpandedAccordion sections={sections} item={localItem} onChildUpdate={handleChildUpdate} />;
};

export default ChildExpandRow;
